<div class="content content-fixed">
  <div>
    <div class="container">
      <div class="mb-3 page-title-box d-sm-flex align-items-center justify-content-between">
        <h3 class="mb-0">{{ 'Assessments orders' | translate }}</h3>
        <div class="mb-3 flex">
          <input type="text" [(ngModel)]="searchTerm" (input)="onSearchChange()" class="form-control"
            placeholder="Search by ID, name, or email" />
            <div class="flex justify-center items-center ml-2">
              <input type="checkbox" (change)="isEnable()">
              <p class="ml-1">Include Deleted</p>
            </div>
        </div>
      </div>

      <div *ngIf="!isLoading" class="assessment_order">
        <div class="scrollable-table-container">
          <table class="table table-striped" [class.no-data]="paginatedData?.length === 0"
            [class.no-data-found]="paginatedCandidates?.length === 0">
            <thead>
              <tr>
                <th *ngFor="let header of headers" (click)="header.sortable && changeSort(header.field)">
                  {{ header.label }}
                  <span *ngIf="sortField === header.field">{{ sortDirection === 1 ? '↑' : '↓' }}</span>
                </th>
              </tr>
            </thead>
            <tbody>
            <tbody>
              <tr *ngFor="let item of paginatedData">
                <td style="text-align: center">{{ item.id }}</td>
               
                <td>
                  {{ item.payload.candidate ? item.payload.candidate.firstName : 'N/A' }}
                  {{ item.payload.candidate ? item.payload.candidate.lastName : '' }}
                </td>
                <td>{{ item.payload.candidate ? item.payload.candidate.email : 'N/A' }}</td>
                <td>{{ item.status }}</td>
                <td>
                  <button (click)="onInvestigate(item)" class="btn btn-sm  btn-uppercase btn-default justify-center flex items-center confirm w-24" [disabled]="isLoading">
                    <i class="fas fa-folder-open text-base iconbg"></i>
                    <i class="fas fa-search -ml-2 -mb-1 dual-color-icon text-xl"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="!paginatedData || paginatedData.length === 0 && !isLoading" class="no-data-found">
            <p>No data found for "{{ searchTerm }}".</p>
          </div>
        </div>
        <ng-template>
          <div *ngIf="error; else loading">
            <p>{{ error }}</p>
          </div>
        </ng-template>

        <ng-template #loading>
          <p>Loading...</p>
        </ng-template>

        <!-- Pagination controls aligned to the right -->

        <app-spinner *ngIf="isLoading"></app-spinner>
      </div>
      <div class="pagination container">
        <div class="pagination-controls">
          <button class="btn btn-sm  btn-uppercase btn-default justify-center flex items-center" (click)="goToFirstPage()"
            [disabled]="currentPage === 1">
            <i class="fa fa-fast-backward" aria-hidden="true"></i>
          </button>
      
          <button class="btn btn-sm  btn-uppercase btn-default justify-center flex items-center" (click)="prevPage()"
            [disabled]="currentPage === 1">
            <i class="fa fa-step-backward" aria-hidden="true"></i>
          </button>
          <!-- Current Page Info -->
          <span class="mt-2">Page {{ currentPage }} of {{ totalPages }}</span>
      
          <button class="btn btn-sm  btn-uppercase btn-default justify-center flex items-center" (click)="nextPage()"
            [disabled]="currentPage >= totalPages">
            <i class="fa fa-step-forward" aria-hidden="true"></i>
          </button>
      
          <button class="btn btn-sm  btn-uppercase btn-default justify-center flex items-center" (click)="goToLastPage()"
            [disabled]="currentPage === totalPages">
            <i class="fa fa-fast-forward" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>